import React from 'react';

import { PayBlock } from './card';

import { PaymentMethodProps } from './payment-method.types';
import { PayButton, PayPrice, PayPriceCommission } from './styled';

import { currencyToSign } from '../../../helpers/currency';
import { getCardCommission } from '../../../helpers/commission';

import { useTranslation } from '../../../i18n';

export const PayWithMasterCard: React.FC<PaymentMethodProps> = ({ price, currency, onPay }) => {
  const [t] = useTranslation('rates');

  const sign = currencyToSign(currency);

  return (
    <PayBlock className="is-hover-shadow">
      <PayPrice>
        {price} {sign}
      </PayPrice>
      <PayPriceCommission>
        (+{t('rates.payments.commission')} {getCardCommission(Number(price))} {sign})
      </PayPriceCommission>{' '}
      <PayButton onClick={() => onPay && onPay()}>
        <img src="/static/img/pay/mastercard.svg" alt="mastercard" />
      </PayButton>
    </PayBlock>
  );
};
